var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loader-container"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},[_c('div',{staticClass:"w-16 h-16 border-b-2 border-gray-900 rounded-full animate-spin"})])
}]

export { render, staticRenderFns }